import React from 'react';
import { MarketingNav } from '@/components/marketing/MarketingNav';
import { HeroSection } from '@/components/marketing/HeroSection';
import { FeaturesSection } from '@/components/marketing/FeaturesSection';
import { WhyLapynoSection } from '@/components/marketing/WhyLapynoSection';
import { UseCasesSection } from '@/components/marketing/UseCasesSection';
import { PricingSection } from '@/components/marketing/PricingSection';
import { SecuritySection } from '@/components/marketing/SecuritySection';
import { FinalCTASection } from '@/components/marketing/FinalCTASection';
import { MarketingFooter } from '@/components/marketing/MarketingFooter';

export default function Landing() {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-950 overflow-x-hidden">
      <MarketingNav />
      <main>
        <HeroSection />
        <FeaturesSection />
        <WhyLapynoSection />
        <UseCasesSection />
        <PricingSection />
        <SecuritySection />
        <FinalCTASection />
      </main>
      <MarketingFooter />
    </div>
  );
}
